import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';
import s from './ProgressBar.module.scss';

type ProgressBarProps = {
  progress: number;
  classNameModifier?: string;
};

const ProgressBar: FC<ProgressBarProps> = ({ progress, classNameModifier }) => {
  const style = {
    width: `${progress}%`,
  };

  return (
    <div className={getClassName(s, 'root', classNameModifier)}>
      <div className={s.progress} style={style} />
    </div>
  );
};

export default ProgressBar;
